// src/menu-items/navigation.jsx
import admin from './admin';
import user from './user';

// Menu groups for the sidebar. Administrators get the everyday workspace menu and, below it, a separate Administration group.
export const getNavigationGroups = (role) => (role === 'admin' ? [{ ...user, id: 'group-workspace', title: 'Workspace' }, admin] : [user]);

// default export for legacy usage
const navigation = user; // default when no role
export default navigation;
